import React, { Component } from 'react';
import 'antd/dist/reset.css';
import { withRouter } from '../../Components/Items'


class PoliticasCancelacion extends Component {

    render() {
        return (
            <div className='registro-carrera-backgorund'>
                <div className="registro-carrera-container">
                    <h1 className="registro-carrera-title">Política de Cancelación y Devolución</h1>
                    <div className="registro-carrera-form">
                        <p>
                            En INTEGRAME DOWN AC, trabajamos para garantizar la satisfacción de nuestros participantes. Sin embargo, debido a la naturaleza de los eventos deportivos, hemos establecido la siguiente Política de Cancelación y Devolución aplicable a los registros realizados a través del sitio web www.todossomosdiferentes.com.
                        </p>
                        <p>
                            <strong>1. Cancelación del Registro por Parte del Participante</strong><br />
                            Una vez completado el proceso de inscripción y confirmado el pago, no se realizarán devoluciones por cancelación voluntaria del registro por parte del participante.
                        </p>
                        <p>
                            El registro es personal e intransferible. No se permiten cambios de nombre ni cesiones a otros participantes.
                        </p>
                        <p>
                            <strong>2. Cancelación del Evento por Parte del Organizador</strong><br />
                            En caso de cancelación del evento por causas de fuerza mayor o decisiones organizativas, INTEGRAME DOWN AC comunicará a los participantes la situación mediante los canales oficiales.
                        </p>
                        <p>
                            Si la cancelación se debe a razones atribuibles al organizador, se ofrecerá la opción de:
                        </p>
                        <ul>
                            <li>Un reembolso parcial o total del monto pagado.</li>
                            <li>Transferir el registro a una nueva fecha propuesta por la organización.</li>
                        </ul>
                        <p>
                            <strong>3. No Presentación del Participante</strong><br />
                            Si un participante no se presenta el día del evento, no tendrá derecho a reembolso ni a compensaciones.
                        </p>
                        <p>
                            <strong>4. Errores en el Proceso de Inscripción</strong><br />
                            En caso de errores en el proceso de inscripción atribuibles al participante, no se realizarán devoluciones ni correcciones después de confirmada la inscripción.
                        </p>
                        <p>
                            Si el error es atribuible al sistema del sitio web o a fallos en el procesamiento del pago por parte del proveedor Conekta, se realizarán las correcciones necesarias sin costo adicional.
                        </p>
                        <p>
                            <strong>5. Reembolsos</strong><br />
                            Los reembolsos, cuando procedan, se procesarán a través del mismo medio de pago utilizado por el participante. Dependiendo de las políticas del proveedor de servicios de pago (Conekta), los tiempos para que el reembolso se refleje pueden variar.
                        </p>
                        <p>
                            <strong>6. Modificaciones al Evento</strong><br />
                            INTEGRAME DOWN AC se reserva el derecho de realizar modificaciones en la fecha, lugar y horarios del evento por razones logísticas o de fuerza mayor. Estas modificaciones serán comunicadas a los participantes oportunamente. No se otorgarán reembolsos en estos casos, salvo que el participante no pueda asistir a la nueva fecha y así lo notifique dentro del plazo indicado.
                        </p>
                        <p>
                            <strong>7. Contacto</strong><br />
                            Para dudas o solicitudes relacionadas con esta Política de Cancelación y Devolución, puede contactarnos a través de:
                        </p>
                        <ul>
                            <li><strong>Correo electrónico:</strong> contacto@todossomosdiferentes.com</li>
                        </ul>
                        <p>
                            <strong>Última Actualización:</strong> 9 de enero de 2025
                        </p>
                    </div>
                </div>
            </div>
        );
    }
}

export default withRouter(PoliticasCancelacion);